import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FaTimesCircle } from 'react-icons/fa'
import { AnimatePresence } from 'framer-motion';

import { Tooltip, PopOut, Animation } from 'components'
import { TagOptions } from 'features'
import { Tag } from 'schema'

const defaultStyle = {
    borderRadius: '10px',
    backgroundColor: 'var(--secondary-color)',
    color: 'white',
    border: '1px solid transparent',
    padding: '0.1rem 0.5rem',
    margin: '0 0.5rem 0 0',
    fontSize: '0.8rem',
    fontWeight: 'normal',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '2rem',
    cursor: 'auto',
}

const Container = styled.div`
    border-radius: ${props => props.style.borderRadius};
    background-color: ${props => props.style.backgroundColor};
    color: ${props => props.style.color};
    border: ${props => props.style.border};
    padding: ${props => props.style.padding};
    margin: ${props => props.style.margin};
    font-size: ${props => props.style.fontSize};
    font-weight: ${props => props.style.fontWeight};
    border-radius: ${props => props.style.borderRadius};
    display: ${props => props.style.display};
    justify-content: ${props => props.style.justifyContent};
    align-items: ${props => props.style.alignItems};
    min-width: ${props => props.style.minWidth};
    cursor: ${props => props.style.cursor};
    line-height: 0.9rem;
    // overflow: hidden;
    // :hover {
    //     filter: brightness(1.2);
    // }
`

const Icon = styled.div`
    color: #F5F5F5;
    opacity: 0.8;
    font-size: var(--icon-size);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 0.2rem;
    :hover {
        filter: brightness(var(--brightness));
    }
`


const TagBlock = props => {
    const {
        tooltip,
        style,
        icon,
        onDelete,
        deleteIcon,
        contextMenu,
        tag
    } = props;

    let updatedStyle = Object.assign({}, defaultStyle, style)
    updatedStyle['backgroundColor'] = tag['color']
    updatedStyle['cursor'] = style.cursor ? style.cursor 
                            : contextMenu ? 'pointer' 
                            : 'auto'
    const content = contextMenu ?
    <PopOut trigger='leftClick' element={<TagOptions tag={tag} tagID={tag['tagID']}/>}>
        <Container style={updatedStyle}>
            {icon}
            <div style={{maxWidth: '8rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{tag['content']}</div>
            {onDelete ? <Icon onClick={() => onDelete(tag)}>{deleteIcon || <FaTimesCircle/>}</Icon> : null}
        </Container>
    </PopOut>
    : <Container style={updatedStyle}>
        {icon}
        <div style={{maxWidth: '8rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{tag['content']}</div>
        {onDelete ? <Icon onClick={() => onDelete(tag)}>{deleteIcon || <FaTimesCircle/>}</Icon> : null}
    </Container>
    

    if(tooltip){
        return (
            <Tooltip title={tooltip} placement='bottom' arrow={true}>
                {content}
            </Tooltip>
        )
    } else {
        return (
            <div>{content}</div>
        )
    }
}

export default TagBlock;

TagBlock.propTypes = {
    tag: PropTypes.instanceOf(Tag).isRequired,
    tooltip: PropTypes.string,
    style: PropTypes.object,
    icon: PropTypes.element,
    onDelete: PropTypes.func,
    deleteIcon: PropTypes.element
}